<script>
	let { category } = $props();
</script>

<span class="inline-block rounded-full bg-wine px-2.5 py-0.5 text-xs font-medium uppercase tracking-wide text-parchment">
	{category}
</span>
